<template>
  <div class="message">
    {{ `Session has completed.` }}
  </div>
</template>


<script>
export default {
  name: "TimerFinishedMessage",
};
</script>